import { randomId } from '@/common/utils';
import { ProductIds } from '@/common/enums';
import { Company, CompanyLicense } from '@/views/companies/interfaces';
import { USERS_CREDS } from './users';
import { PLAY_PRODUCT, CANVAS_PRODUCT } from './productsList';

export const PLAY_LICENSE: CompanyLicense = {
  id: ProductIds.PLAY,
  totalUsers: 2,
  trial: false,
  seats: 2,
  durationLength: 30,
  durationType: 'days',
  startDate: 1644249138000,
  isEnabled: true,
  productId: PLAY_PRODUCT.id,
  product: PLAY_PRODUCT,
};

export const CANVAS_LICENSE: CompanyLicense = {
  id: ProductIds.CANVAS,
  totalUsers: 2,
  trial: false,
  seats: 2,
  durationLength: 30,
  durationType: 'days',
  startDate: 1644249138000,
  isEnabled: true,
  productId: CANVAS_PRODUCT.id,
  product: CANVAS_PRODUCT,
};

export const BASE_COMPANY = {
  id: randomId(),
  name: '',
  createdAt: new Date('2022/02/07').toString(),
  updatedAt: new Date('2022/02/07').toString(),
  lastUsed: new Date(new Date().setDate(new Date().getDate() - 5)).toString(),
  deletedAt: null,
  lastLogin: null,
  licenses: [PLAY_LICENSE, CANVAS_LICENSE],
};

const BASE_DELETED_COMPANY = {
  ...BASE_COMPANY,
  deletedBy: [{
    createdAt: new Date('2022/04/01').toString(),
    user: { email: USERS_CREDS[0].email },
  }],
};

export const COMPANIES_LIST: Company[] = [
  {
    ...BASE_COMPANY,
    id: '123',
    name: 'Craftsman+',
  },
  {
    ...BASE_COMPANY,
    id: '346',
    name: 'Adidas',
    licenses: [
      {
        ...PLAY_LICENSE,
        startDate: 1644940338000,
      },
      // CANVAS_LICENSE,
    ],
    lastUsed: new Date('2022/04/05').toString(),
  },
  {
    ...BASE_COMPANY,
    id: '789',
    name: 'Nike',
    licenses: [{
      ...PLAY_LICENSE,
      startDate: 1643817138000,
    },
    CANVAS_LICENSE,
    ],
    lastUsed: new Date('2022/04/11').toString(),
  },
  {
    ...BASE_COMPANY,
    id: '146',
    name: 'Test(noDuration)',
    lastUsed: null,
    licenses: [{
      ...PLAY_LICENSE,
      durationLength: 0,
    }],
    lastLogin: new Date('2022/04/11').toString(),
  },
  {
    ...BASE_DELETED_COMPANY,
    id: '345',
    name: 'Deleted Company',
    deletedAt: new Date('2022/04/01').toString(),
  },
  {
    ...BASE_DELETED_COMPANY,
    id: '9999',
    name: 'Deleted Company 2',
    deletedAt: new Date('2022/05/01').toString(),
  },
  {
    ...BASE_DELETED_COMPANY,
    id: randomId(),
    name: 'Deleted Test Company',
    deletedAt: new Date('2022/06/01').toString(),
  },
];

export default COMPANIES_LIST;
